export default {
  title: {
    en: 'Oops..',
  },
  text: {
    en: 'Something went wrong. Please try again later.',
  },
  loginMethodNotAllowedTitle: {
    en: 'Login Method Not Allowed',
  },
  loginMethodNotAllowed: {
    en: 'The account you are trying to access was created using an external wallet.To access it you need to login with the same external wallet Switch to {chain} Chain',
  },
}
